const FONT_FILE_EXTENSION = /\.(ttf|otf)$/i;

/** Default font family name proposed from the uploaded file: `Inter-Bold.ttf` → `Inter-Bold`. */
export const getFontFamilyFromFileName = (fileName: string) => {
  const family = fileName.replace(FONT_FILE_EXTENSION, '').trim();
  return family.length > 0 ? family : fileName;
};
